import { Grid } from "@material-ui/core";
import { useInfiniteQuery } from "@tanstack/react-query";
import { Fragment, useState } from "react";
import { Button } from "../../../components/Button";
import { getParticipantHighlights } from "../../../learning/learning.service";
import { Highlight } from "../../../shared/components/highlights";
import { HighlightStarsIcon } from "../../../shared/icons";
import { HighlightsStyles } from "./highlights.styles";

const PAGE_SIZE = 24;
const INIT_PAGE = 1;

export const Highlights = () => {
  const classes = HighlightsStyles();

  const [page, setPage] = useState(INIT_PAGE);

  const { data, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: ["highlights"],
      queryFn: ({ pageParam }) =>
        getParticipantHighlights({
          pageNumber: pageParam === true ? INIT_PAGE : pageParam,
          pageSize: PAGE_SIZE,
        }),
      retry: 0,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => {
        const totalPage = Math.floor(lastPage.totalRecords / PAGE_SIZE);

        return page <= totalPage;
      },
    });

  const onNextPage = () => {
    setPage((prevState) => {
      const statePage = prevState + 1;
      fetchNextPage({ pageParam: statePage });
      return statePage;
    });
  };

  return (
    <Grid container>
      {data?.pages.map((page, i) => {
        return (
          <Fragment key={i}>
            {page?.data.map((item) => {
              return (
                <Grid item xs={6} key={item.id}>
                  <Highlight
                    icon={<HighlightStarsIcon />}
                    key={item.id}
                    title={item.type}
                    description={item.title}
                    date={new Date(item.createdAt)}
                  />
                </Grid>
              );
            })}
          </Fragment>
        );
      })}
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        className={classes.button}
      >
        {hasNextPage && (
          <Button
            onClick={() => {
              if (!isFetchingNextPage) {
                onNextPage();
              }
            }}
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? "Loading more..." : "Load more"}
          </Button>
        )}
        <div>{isFetching && !isFetchingNextPage ? "Loading" : null}</div>
      </Grid>
    </Grid>
  );
};
